const GLobalSettings: IGLobalSettings = {
  development: {
    meta: {
      property: 'og:url',
      content: 'https://test-minisite2.hunteredge.me/vacancy',
    },
    runtimeConfig: {
      recapchaSecret: '6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe',
      smtpMail: '',
      smtpPass: '',
      smtpHost: '',
      smtpService: '',
      smtpPort: 25,
      smtpIsSecure: false,

      public: {
        apiUrl: 'https://jobsiteapitest.hunterhrms.com/api',
        sendMailApi: '/api/submit',
        apiTransportRoute: '/api/getVacancy',
        apiJobsRoute: '/api/jobs',
        pageSize: 11,
        baseUrl: 'https://test-minisite2.hunteredge.me',
        recapchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
        ipDataKey: '9019d4b977b41bd15ed7476d1d6b1ee889c163a8ca0afbcdaaac1dad',
        additionalFilesEnabled: true,
        maxFileSize: 10, // 10MB
        maxAdditionalFilesSize: 20, // 20MB
        maxAdditionalFiles: 5, // Maximum number of additional files
      },
    },
  },
  staging: {
    meta: {
      property: 'og:url',
      content: 'https://test-minisite2.hunteredge.me/vacancy',
    },
    runtimeConfig: {
      recapchaSecret: '6LdbTkMUAAAAAJKMVWJ4jpr5esfv-OOGFJjhFncC',
      smtpMail: '',
      smtpPass: '',
      smtpHost: '',
      smtpService: '',
      smtpPort: 25,
      smtpIsSecure: false,

      public: {
        apiUrl: 'https://jobsiteapi-test.hunteredge.me/api',
        sendMailApi: '/api/submit',
        apiTransportRoute: '/api/getVacancy',
        apiJobsRoute: '/api/jobs',
        pageSize: 11,
        baseUrl: 'https://test-minisite2.hunteredge.me',
        recapchaSiteKey: '6LdbTkMUAAAAAJKMVWJ4jpr5esfv-OOGFJjhFncC',
        ipDataKey: '9019d4b977b41bd15ed7476d1d6b1ee889c163a8ca0afbcdaaac1dad',
        additionalFilesEnabled: true,
        maxFileSize: 10, // 10MB
        maxAdditionalFilesSize: 20, // 20MB
        maxAdditionalFiles: 5, // Maximum number of additional files
      },
    },
  },
  production: {
    meta: {
      property: 'og:url',
      content: 'https://minisite.hunter-edge.me/vacancy',
    },
    runtimeConfig: {
      recapchaSecret: '6LeGp04gAAAAAHE7YN42oLmEyAoMiRm53m66Lo7c',
      smtpMail: '',
      smtpPass: '',
      smtpHost: '',
      smtpService: '',
      smtpPort: 25,
      smtpIsSecure: false,

      public: {
        apiUrl: 'https://jobsite-api.hunterhrms.com/api',
        sendMailApi: '/api/submit',
        apiTransportRoute: '/api/getVacancy',
        apiJobsRoute: '/api/jobs',
        pageSize: 11,
        baseUrl: 'https://minisite.hunter-edge.me',
        recapchaSiteKey: '6LeGp04gAAAAAHE7YN42oLmEyAoMiRm53m66Lo7c',
        ipDataKey: '9019d4b977b41bd15ed7476d1d6b1ee889c163a8ca0afbcdaaac1dad',
        additionalFilesEnabled: true,
        maxFileSize: 10, // 10MB
        maxAdditionalFilesSize: 20, // 20MB
        maxAdditionalFiles: 5, // Maximum number of additional files
      },
    },
  },
};

export { GLobalSettings };
type RuntimeConfig = {
  recapchaSecret: string;
  smtpMail: string;
  smtpPass: string;
  smtpHost: string;
  smtpService: string;
  smtpPort: number;
  smtpIsSecure: boolean;
  public: {
    apiUrl: string;
    sendMailApi: string;
    apiTransportRoute: string;
    apiJobsRoute: string;
    pageSize: number;
    baseUrl: string;
    recapchaSiteKey: string;
    ipDataKey: string;
    additionalFilesEnabled?: boolean;
    maxFileSize: number; // 10MB
    maxAdditionalFilesSize: number; // 20MB
    maxAdditionalFiles: number; // Maximum number of additional files
  };
};

interface IGLobalSettings {
  development: {
    meta: {};
    runtimeConfig: RuntimeConfig;
  };
  staging: {
    meta: {};
    runtimeConfig: RuntimeConfig;
  };
  production: {
    meta: {};
    runtimeConfig: RuntimeConfig;
  };
}
